import * as types from '../mutation-types';


// initial state
const state = {
  investorsGeographies: [],
  investorsGeography: {},
};


// getters
const getters = {
  investorsGeographies: stateFreezed => stateFreezed.investorsGeographies,
  investorsGeography: stateFreezed => stateFreezed.investorsGeography,
};

// actions
const actions = {
  fetchInvestorsGeographies({ commit }, params) {
    params.$http.get(`/${params.lang}/api/investorsgeographies/`)
    .then((response) => {
      if (response.body.content && response.body.content.investors_geography) {
        commit(types.RECEIVE_INVESTORS_GEOGRAPHIES, response.body.content.investors_geography);
      }
    });
  },
};

// mutations
const mutations = {
  [types.RECEIVE_INVESTORS_GEOGRAPHIES](stateFreezed, investorsGeographyFetched) {
    const st = stateFreezed;
    st.investorsGeographies = investorsGeographyFetched.list;
  },
  [types.FETCH_INVESTORS_GEOGRAPHIES](stateFreezed, investorsGeography) {
    const st = stateFreezed;
    st.investorsGeography = st.investorsGeography.item.find(o => o.$slug === investorsGeography);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/investorsGeographies.js